import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-header" }
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = {
  key: 0,
  class: "login-footer"
}

import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import TheLogoImg from '@/core/components/TheLogoImg.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginLayout',
  props: {
    pageTitle: {}
  },
  setup(__props: any) {

const store = useStore<AppStore>();
const props = __props;
const loginWrapper = ref<HTMLDivElement>();

const setTitle = () => {
	document.title = `${props.pageTitle} - ${store.getters.appName}`;
};

const handleWhitelabel = () => {
	const theme = store.getters.activeWhitelabeling;
	const div = loginWrapper.value as HTMLDivElement;

	if (theme && theme.background_path) {
		div.style.backgroundImage = `url(${process.env.BASE_URL}${theme.background_path})`;
	} else {
		div.style.backgroundImage = '';
	}
};

watch(() => store.getters.appName, setTitle);
onMounted(setTitle);

watch(() => store.getters.activeWhitelabeling, handleWhitelabel);
onMounted(handleWhitelabel);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "login-wrapper",
    ref_key: "loginWrapper",
    ref: loginWrapper
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(TheLogoImg)
      ]),
      _createElementVNode("main", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (!!_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})